var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.withoutBackground ? '' : 'btn btn-primary',style:(_vm.withoutBackground ? '' : _vm.styleObject),attrs:{"download":_vm.fileName ? _vm.fileName : null,"href":_vm.href}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }